var EventEmitter = require('events');
var walletEvents = new EventEmitter();
export default walletEvents;